import {
  fetchBillersRequestPayload,
  // getBillerByCategoryPayload,
} from "../../../store/features/billers/billerActions";
import { Biller } from "../../../store/features/billers/billerTypes";
import billerHttp, {
  billerDetailsHttp,
} from "../../axios.services/http/instances/billerHttp";

// interface fetchBillersApiParams {
//   page: number;
//   limit: number;
//   search?: string;
//   region?: string;
//   category?: string;
// }
// const toIsoOffset = (d = new Date()) => {
//   const pad = (n:number)=>String(n).padStart(2,"0");
//   const tzMin = -d.getTimezoneOffset();
//   const sign = tzMin >= 0 ? "+" : "-";
//   const hh = pad(Math.floor(Math.abs(tzMin)/60));
//   const mm = pad(Math.abs(tzMin)%60);
//   return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}${sign}${hh}:${mm}`;
// };

// type BillFetchInput = {
//   billerId: string;
//   values: {
//     mobileNumber: string;          // user form
//     last4: string;                 // user form
//     email?: string;                // user form
//   };
//   meta?: ClientMeta;               // optional browser meta (from hook or elsewhere)
// };
export type PaymentRequestBody = {
  refId: string;
  // agentId: string;
  billerId: string;
  customerParams: Record<string, string>;
  customerDetails: Record<string, string>; // { "REMITTER NAME": "..." }
  deviceDetails: { MAC: string; IP: string };
  customerMobile: string;
  isQuickPay: string; // "true"/"false" string as per contract
  amount: { amount: string };
  paymentInformation: Record<string, string>; // e.g. { "VPA": "user@upi" } or CardNum|AuthCode, etc.
  txn: { ts: string; paymentRefId: string };
  paymentMethod: { splitPay: string; OFFUSPay: string; paymentMode: string };
};

export type BillFetchRequestBody = {
  refId: string;
  agentId: string;
  billerId: string;
  customerMobileNumber: string;
  customerParams: Record<string, string>;
  customerDetails: Record<string, string>;
  deviceDetails: { MAC: string; IP: string };
  timeStamp: string; // 2025-09-26T17:02:00+05:30
};
// function normalizeResponseParams(input: any): BillerResponseParams {
//   // provider variability guard: handle object or array
//   // want: { amountOptions: [{ amountBreakupSet: string[] }] }
//   const amountOptionsRaw = input?.amountOptions;

//   if (Array.isArray(amountOptionsRaw)) {
//     return {
//       amountOptions: amountOptionsRaw.map((x: any) => ({
//         amountBreakupSet: Array.isArray(x?.amountBreakupSet)
//           ? x.amountBreakupSet
//           : [],
//       })),
//     };
//   }

//   if (amountOptionsRaw && typeof amountOptionsRaw === "object") {
//     const set = amountOptionsRaw.amountBreakupSet;
//     return {
//       amountOptions: [
//         {
//           amountBreakupSet: Array.isArray(set) ? set : set ? [String(set)] : [],
//         },
//       ],
//     };
//   }

//   return { amountOptions: [] };
// }

// Map envelope → Biller (and fix minor field inconsistencies if needed)
// function mapEnvelopeToBiller(env: BillerDetailsEnvelope): Biller {
//   const d = env.data;
//   return {
//     ...d,
//     // ensure response params shape normalized
//     billerResponseParams: normalizeResponseParams(d?.billerResponseParams),
//   };
// }

export interface planReq {
  search: string[];
}

export interface billValidationReq {
  billerId: string;
  customerParams: Record<string, string>;
}
const billerService = {
  fetchBillersApi: async ({
    page,
    limit,
    search,
    region,
    category,
  }: fetchBillersRequestPayload): Promise<{ data: Biller[] }> => {
    // console.log(page, limit, search, region, category);

    const response = await billerHttp.get(`/api/Biller/GetAllBillers`, {
      params: { page, limit, search, region, category },
    });

    // console.log({ response });

    return response;
  },

  // getBillerById: async (id: string) => {
  //   console.warn("getBillerById not implemented yet", id);
  // },
  getBillerByCategory: async (
    category: string,
  ): Promise<{ data: Biller[] }> => {
    // console.log({ category });

    const response = await billerHttp.get(
      `/api/Biller/GetBillerByCategory/${category}`,
    );
    // console.log({ response });

    return response;
  },

  getBillerDetails: async (billerId: string): Promise<Biller> => {
    const response = await billerHttp.get(
      `/api/Biller/GetBillerByBillerId/${billerId}`,
    );
    // return response?.data;
    return response?.data;
  },

  fetchPlans: async (params: planReq) => {
    // console.log("planreq data", params);

    const response = await billerDetailsHttp.post(
      `/api/v1/biller/plans`,
      params,
    );

    // console.log("plan::", response);

    return await response?.data;
  },
  billFetch: async (body: BillFetchRequestBody) => {
    // console.log({ body });

    const response = await billerDetailsHttp.post(
      `/api/v1/bill/billfetch`,
      body,
    );
    // console.log({ response });

    return response?.data;
  },
  billValidation: async (params: billValidationReq) => {
    // console.log("billvalidation req data: ", params);
    const response = await billerDetailsHttp.post(
      `/api/v1/bill/validation`,
      params,
    );

    // console.log("billvalidation", response);

    return response?.data;
  },
  billPayment: async (body: PaymentRequestBody) => {
    // console.log("PaymentRequestBody::", body);

    const response = await billerDetailsHttp.post(`/api/v1/bill/payment`, body);

    // console.log("payment response:: ", response);

    return response;
  },
};

export default billerService;

// agentId
// :
// "IF31IF03INT524833871"
// amount
// :
// {amount: '250000'}
// billerId
// :
// "OU12BB000NATKB"
// customerDetails
// :
// {REMITTER NAME: 'SANJAY KHAMESARA'}
// customerMobile
// :
// "7378926752"
// customerParams
// :
// {Mobile Number: '7378926752', Last 4 digit of primary credit card number: '1864'}
// deviceDetails
// :
// {MAC: '04-D9-C8-64-5E-3F', IP: '122.160.88.102'}
// isQuickPay
// :
// "No"
// paymentInformation
// :
// {VPA: '9651138985@ybl', IFSC|AccountNo: 'string', CardNum|AuthCode: 'string', MMID|MobileNo (Mobile Money Identifier): 'string', WalletName|MobileNo: 'string'}
// paymentMethod
// :
// {splitPay: 'No', OFFUSPay: 'No', paymentMode: 'UPI'}
// refId
// :
// "CashQuin1sp6eP8y9HLa1WfqiIE53250719"
// txn
// :
// {ts: '2025-11-21T12:50:34+05:30', paymentRefId: '139786275'}

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
//   timeout: 15000,
// });

// // stepwise APIs according to flow diagram
// const getBillerDetails = (billerId: string) =>
//   api.get(`/billers/${billerId}`);

// const fetchPlans = (billerId: string, params: any) =>
//   api.post(`/billers/${billerId}/plans`, params);

// const billFetch = (billerId: string, params: any) =>
//   api.post(`/billers/${billerId}/fetch`, params);

// const billValidation = (billerId: string, params: any) =>
//   api.post(`/billers/${billerId}/validate`, params);

// const billPayment = (billerId: string, params: any) =>
//   api.post(`/billers/${billerId}/payment`, params);

// export default {
//   getBillerDetails,
//   fetchPlans,
//   billFetch,
//   billValidation,
//   billPayment,
// };
